import React from 'react';
import { PageHeader, PageTitle } from '../../shared/Page';

const BusinessesSavingsPageHeader = () => (
  <PageHeader>
    <PageTitle>Save the environment and save money</PageTitle>
  </PageHeader>
);

export { BusinessesSavingsPageHeader };